const paymentFrequencyOptions = [
  { text: "Every Week", value: "weekly", display: "Weekly" },
  { text: "Every Two Weeks", value: "biweekly", display: "Biweekly" },
  { text: "Twice a Month", value: "semimonthly", display: "Bimonthly" },
  { text: "Once a Month", value: "monthly", display: "Monthly" }
]

const monthOptions = [
  { value: "1", text: "January" },
  { value: "2", text: "February" },
  { value: "3", text: "March" },
  { value: "4", text: "April" },
  { value: "5", text: "May" },
  { value: "6", text: "June" },
  { value: "7", text: "July" },
  { value: "8", text: "August" },
  { value: "9", text: "September" },
  { value: "10", text: "October" },
  { value: "11", text: "November" },
  { value: "12", text: "December" }
]

const PAY_FREQUENCY_DIVISOR = {
  annually: 1,
  semiannually: 2,
  quarterly: 4,
  monthly: 12,
  weekly: 52,
  biweekly: 26,
  semimonthly: 24
}

export { paymentFrequencyOptions, monthOptions, PAY_FREQUENCY_DIVISOR }
